import { cx } from '@/utils';
import { TbWorld } from 'react-icons/tb';

import SvgBgPrimary from '@/components/common/SvgBgPrimary/SvgBgPrimary';

export const QuickAccessIcon = ({
  image,
  height = 42,
  width = 42,
  colorClass = 'text-primaryDark',
  className,
}: {
  image?: any;
  height?: number;
  width?: number;
  colorClass?: string;
  className?: string;
}) => {
  // Si no hay imagen, mostrar un ícono de fallback
  if (!image?.downloadUrl) {
    return (
      <div
        className="flex flex-shrink-0 items-center justify-center self-center rounded-lg"
        style={{ width: `${width}px`, height: `${height}px` }}
      >
        <TbWorld className="text-primary" size={width * 0.6} />
      </div>
    );
  }

  return (
    <div className={cx('flex-shrink-0 self-center', className)}>
      <SvgBgPrimary
        height={height}
        width={width}
        svgURL={image.downloadUrl}
        colorClass={colorClass}
      />
    </div>
  );
};
